import React from "react";
import Support from "./Support/Support";
import Implementations from "./Support/Implementations";
import Task from "./Support/Task";
import QuickFilter from "./Support/QuickFilter";

export default function Home() {
  return (
    <>
      {
        <div>
          <div
            className="row table-panel-header mb-2"
            style={{ display: "none" }}
          >
            <div className="col-md-8 col-sm-12">
              <h6>Dashboard</h6>
            </div>
          </div>
          <div className="row" style={{ display: "none" }}>
            <div className="col-md-4">
              <div className="box-shadow">
                <div className="row flex-center">
                  <div className="col-md-9">
                    <p>
                      <span>Total Tickets (last 30d)</span>
                    </p>
                    <h2>
                      <span>0</span>
                    </h2>
                  </div>
                  <div className="col-md-3">
                    <div className="box-shadow-img">
                      <span style={{ display: "none" }}>5,3,9,6,5,9,7</span>
                      <svg height="28" width="48">
                        <rect
                          fill="#e74c3c"
                          x="1.3714285714285717"
                          y="12.444444444444443"
                          width="4.114285714285715"
                          height="15.555555555555557"
                         />
                        <rect
                          fill="#e74c3c"
                          x="8.228571428571428"
                          y="18.666666666666668"
                          width="4.114285714285716"
                          height="9.333333333333332"
                         />
                        <rect
                          fill="#e74c3c"
                          x="15.085714285714287"
                          y="0"
                          width="4.1142857142857086"
                          height="28"
                         />
                        <rect
                          fill="#e74c3c"
                          x="21.942857142857147"
                          y="9.333333333333336"
                          width="4.114285714285707"
                          height="18.666666666666664"
                         />
                        <rect
                          fill="#e74c3c"
                          x="28.800000000000004"
                          y="12.444444444444443"
                          width="4.114285714285707"
                          height="15.555555555555557"
                         />
                        <rect
                          fill="#e74c3c"
                          x="35.65714285714286"
                          y="0"
                          width="4.114285714285707"
                          height="28"
                         />
                        <rect
                          fill="#e74c3c"
                          x="42.51428571428572"
                          y="6.222222222222221"
                          width="4.114285714285707"
                          height="21.77777777777778"
                         />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="box-shadow">
                <div className="row flex-center">
                  <div className="col-md-9">
                    <p>
                      <span>Tickets Completed</span>
                    </p>
                    <h2>
                      <span>--%</span>
                    </h2>
                  </div>
                  <div className="col-md-3">
                    <div className="box-shadow-img">
                      <span style={{ display: "none" }}>5,3,9,6,5,9,7</span>
                      <svg height="24" width="24">
                        <path
                          d="M 12 0 A 12 12 0 1 1 11.99 0 L 11.99 6 A 6 6 0 1 0 12 6"
                          fill="#ccc"
                         />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="box-shadow">
                <div className="row flex-center">
                  <div className="col-md-9">
                    <p>
                      <span>Avg Response Time</span>
                    </p>
                    <h2>
                      <span>0 hours</span>
                    </h2>
                  </div>
                  <div className="col-md-3">
                    <div className="box-shadow-img">
                      <span style={{ display: "none" }}>5,3,9,6,5,9,7</span>
                      <svg height="28" width="100%">
                        <polygon
                          fill="#d1e4f6"
                          points="0 27.5 0 12.5 7.111111111111111 18.5 14.222222222222221 0.5 21.333333333333332 9.5 28.444444444444443 12.5 35.55555555555556 0.5 42.666666666666664 6.5 49.77777777777777 18.5 56.888888888888886 12.5 64 21.5 64 27.5"
                         />
                        <polyline
                          fill="none"
                          points="0 12.5 7.111111111111111 18.5 14.222222222222221 0.5 21.333333333333332 9.5 28.444444444444443 12.5 35.55555555555556 0.5 42.666666666666664 6.5 49.77777777777777 18.5 56.888888888888886 12.5 64 21.5"
                          stroke="#0288d1"
                          strokeWidth="1"
                          strokeLinecap="square"
                         />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-sm-12">
                <QuickFilter />
              </div>

            {(((sessionStorage.type === "S" ||
              sessionStorage.type === "D" ||
              sessionStorage.type === "") &&
              sessionStorage.viewOnly === "N" &&
              sessionStorage.fullAccess === "N") ||
              ((sessionStorage.type === "CS" ||
                sessionStorage.type === "IT" ||
                sessionStorage.type === "I" ||
                sessionStorage.type === "M" ||
                sessionStorage.type === "CSM") &&
                sessionStorage.viewOnly === "N" &&
                sessionStorage.fullAccess === "Y")) && (
              <div className="col-md-12 col-sm-12">
                <Support />
              </div>
            )}

            {(((sessionStorage.type === "S" ||
              sessionStorage.type === "D" ||
              sessionStorage.type === "") &&
              sessionStorage.viewOnly === "N" &&
              sessionStorage.fullAccess === "N") ||
              ((sessionStorage.type === "CS" ||
                sessionStorage.type === "IT" ||
                sessionStorage.type === "I" ||
                sessionStorage.type === "M" ||
                sessionStorage.type === "CSM") &&
                sessionStorage.viewOnly === "N" &&
                sessionStorage.fullAccess === "Y")) && (
              <div className="col-md-12 col-sm-12">
                <Task />
              </div>
            )}

            {((sessionStorage.type === "D" &&
              sessionStorage.viewOnly === "N" &&
              sessionStorage.fullAccess === "N") ||
              (sessionStorage.type === "IT" &&
                sessionStorage.viewOnly === "N" &&
                sessionStorage.fullAccess === "Y")) && (
              <div className="col-md-12 col-sm-12">
                <Implementations />
              </div>
            )}

            {/* 
            {
              <div className="col-md-12 col-sm-12">
                <Implementations />
              </div>
            } */}
          </div>
        </div>
      }
    </>
  );
}
